import { ELocale } from "@/app/types/locale";
import {
  IAverageInsights,
  ICorrelationsInsights,
  ICorrelationsInsightsMetadata,
  IMealsInsights,
  IMealsInsightsMetadata,
  ISelectedInsights,
  ISymptomsInsights,
  ISymptomsInsightsMetadata,
} from "./types";
import { getItemSessionStorage } from "@/lib/utils";
import { ELocalStorageKeys } from "@/app/types/localStorage";
import { getApi, patchApi } from "../../config";
import { ErrorResponse } from "@/app/types/error";

export const getPatientMealsInsights = async (
  patientId: string,
  metadata: IMealsInsightsMetadata,
  locale: ELocale
): Promise<IMealsInsights | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);
  const response = await patchApi<IMealsInsights | ErrorResponse>(
    `/provider/graph/patient/${patientId}/meal?locale=${locale}`,
    { body: metadata },
    token
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientSymptomsInsights = async (
  patientId: string,
  metadata: ISymptomsInsightsMetadata,
  locale: ELocale
): Promise<ISymptomsInsights | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);
  const response = await patchApi<ISymptomsInsights | ErrorResponse>(
    `/provider/graph/patient/${patientId}/symptom?locale=${locale}`,
    { body: metadata },
    token
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientCorrelationsInsights = async (
  patientId: string,
  metadata: ICorrelationsInsightsMetadata,
  locale: ELocale
): Promise<ICorrelationsInsights | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);
  const response = await patchApi<ICorrelationsInsights | ErrorResponse>(
    `/provider/graph/patient/${patientId}/correlation?locale=${locale}`,
    { body: metadata },
    token
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientWeeklyAverage = async (
  patientId: string
): Promise<IAverageInsights | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);
  const response = await getApi<IAverageInsights | ErrorResponse>(
    `/provider/graph/patient/${patientId}/average`,
    {},
    token
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};

export const getPatientSelectedInsights = async (
  patientId: string
): Promise<ISelectedInsights | ErrorResponse> => {
  const token = await getItemSessionStorage(ELocalStorageKeys.TOKEN);
  const response = await getApi<ISelectedInsights | ErrorResponse>(
    `/provider/graph/patient/${patientId}/selected`,
    {},
    token
  );
  if (response.status === "fail") return response as ErrorResponse;
  return response;
};
